import React from 'react';

function Play() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13">
      <path fill="currentColor" d="M0 0l7.902 6.3L0 12.603V0zm1 10.526L6.298 6.3 1 2.077v8.45z" />
    </svg>
  );
}

export default Play;
